import React, { useEffect, useState } from 'react';
import { Box, Loader, Text } from '@mantine/core';
import { useParams, useSearchParams } from 'react-router-dom';
import { MobileTopAccordion } from 'components/Worker/Work/MobileTopAccordion.tsx';
import { BackLinkComponent } from 'components/Worker/Task/Components/BackLinkComponent.tsx';
import { FindProjectTaskResponseDto, useLazyProjectTasksTreeFindByJobIdQuery } from 'store/api/projectTasks.tsx';
import { EmptyCalendarDate } from 'components/Worker/Calendar/Nested/EmptyCalendarDate.tsx';
import { WorkTaskTree } from 'components/Worker/Work/WorkTaskTree.tsx';
import dayjs from 'utils/dayjs.ts';
import { getWeekdayName } from 'components/Worker/Dashboard.utils.ts';


export const WorkPageLayout: React.FC<{ variant: 'overdue' | 'calendar' }> = ({ variant }) => {

    const [searchParams] = useSearchParams()
    const date = searchParams.get('date');

    const { workId } = useParams()

    const [workDate, setWorkDate] = useState(JSON.parse(String(localStorage.getItem('workDate'))))
    const [findTaskApiCall, { isLoading: isTaskLoading }]  = useLazyProjectTasksTreeFindByJobIdQuery()
    const [tasksTree, setTasksTree] = useState<FindProjectTaskResponseDto[][] | undefined>(undefined)

    useEffect(() => {
        if (!workId) return
        findTaskApiCall(workId)
            .unwrap()
            .then(({ data }) => setTasksTree(data))

    }, [findTaskApiCall, workId]);

    useEffect(() => {
        if(date && date !== 'null') {
            setWorkDate(date)
            localStorage.setItem('workDate', JSON.stringify(date))
        } else {
            setWorkDate(JSON.parse(String(localStorage.getItem('workDate'))))
        }
    }, [date])

    return isTaskLoading && !tasksTree ?
        <Loader /> :
        <>
            <BackLinkComponent route={variant === 'overdue' ? '/overdue' : date && date !== 'null' ? `/?date=${date}` : '/'}>
                <Text c={'#FFFFFF'} fw={500} style={{ fontSize: '16px' }}>{`${getWeekdayName(workDate)}, ${dayjs(workDate).format('DD MMM')}`}</Text>
            </BackLinkComponent>
            { tasksTree && <MobileTopAccordion tasksTree={tasksTree} />}
            <Box h={80} />
            {tasksTree && tasksTree.length ?
                <WorkTaskTree tasksTree={tasksTree} /> :
                <EmptyCalendarDate string={'Нет задач'}/>}
        </>
}
